<template></template>

<script>
// asyncComputed: {
//     drivers: {
//         async get() {
//             if (!!this.contractor) {
//                 this.loadingDrivers = true;
//                 return DriverService.getDriversByContractor(this.contractor).then(result => {
//                     this.loadingDrivers = false;
//                     return result.data.result;
//                 }).catch(err =>{
//                     this.loadingDrivers = false;
//                     console.log("Error, get drivers");
//                     return [];
//                 });
//             } else {
//                 return DriverService.getAllDrivers().then(result => {
//                     this.loadingDrivers = false;
//                     return result.data.result;
//                 }).catch(err =>{
//                     this.loadingDrivers = false;
//                     console.log("Error, get drivers");
//                     return [];
//                 });
//             }
//         },
//         default: []
//     },
//     vehicles: {
//         async get() {
//             if (!!this.contractor) {
//                 this.loadingVehicles = true;
//                 return VehicleService.getVehiclesByContractor(this.contractor).then(result => {
//                     this.loadingVehicles = false;
//                     return result.data.result;
//                 }).catch(err =>{
//                     this.loadingVehicles = false;
//                     console.log("Error, get vehicles");
//                     return [];
//                 });
//             } else {
//                 if(!!this.driver) {
//                     this.loadingVehicles = true;
//                     return VehicleService.getVehiclesByContractor(this.driverObj.contractor.id).then(result => {
//                         this.loadingVehicles = false;
//                         return result.data.result;
//                     }).catch(err =>{
//                         this.loadingVehicles = false;
//                         console.log("Error, get vehicles");
//                         return [];
//                     });
//                 } else {
//                     return VehicleService.getAllVehicles().then(result => {
//                         this.loadingVehicles = false;
//                         return result.data.result;
//                     }).catch(err =>{
//                         this.loadingVehicles = false;
//                         console.log("Error, get vehicles");
//                         return [];
//                     });
//                 }
//             }
//         },
//         default: []
//     }
// },
export default {};
</script>

<style>
</style>
